const SPINNER_SIZES = {
  sm: { box: "w-8 h-8", border: "border-2", inset: "inset-[5px]" },
  md: { box: "w-12 h-12", border: "border-[3px]", inset: "inset-[7px]" },
  lg: { box: "w-16 h-16", border: "border-[3px]", inset: "inset-[9px]" },
};

export function LoadingSpinner({ size = "md", className = "" }) {
  const { box, border, inset } = SPINNER_SIZES[size] ?? SPINNER_SIZES.md;

  return (
    <div className={`relative ${box} ${className}`} role="status" aria-label="در حال بارگذاری">
      <div
        className={`absolute inset-0 rounded-full ${border}`}
        style={{ borderColor: "rgba(0, 192, 185, 0.18)" }}
      />
      <div
        className={`absolute inset-0 rounded-full ${border} border-transparent animate-spin`}
        style={{
          borderTopColor: "#00C0B9",
          borderRightColor: "#914985",
        }}
      />
      <div
        className={`absolute ${inset} rounded-full`}
        style={{ background: "rgba(253, 237, 250, 0.5)" }}
      />
    </div>
  );
}

export default function Loading({
  message = "در حال بارگذاری...",
  fullScreen = false,
  size = "md",
  className = "",
}) {
  const content = (
    <div className={`flex flex-col items-center justify-center gap-4 ${className}`}>
      <LoadingSpinner size={size} />
      {message && (
        <p className="text-[13px] yekanSemiBold text-[#737373] text-center">{message}</p>
      )}
    </div>
  );

  if (fullScreen) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FAFAFA]">
        {content}
      </div>
    );
  }

  return (
    <div className="w-full flex items-center justify-center py-16">
      {content}
    </div>
  );
}
